import { render, staticRenderFns } from "./SelectedCompaignModal.vue?vue&type=template&id=23644e33&scoped=true&"
import script from "./SelectedCompaignModal.vue?vue&type=script&lang=js&"
export * from "./SelectedCompaignModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectedCompaignModal.vue?vue&type=style&index=0&id=23644e33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23644e33",
  null
  
)

export default component.exports